import { render, staticRenderFns } from "./contractAttachment.vue?vue&type=template&id=706ac806&scoped=true"
import script from "./contractAttachment.vue?vue&type=script&lang=js"
export * from "./contractAttachment.vue?vue&type=script&lang=js"
import style0 from "./contractAttachment.vue?vue&type=style&index=0&id=706ac806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ac806",
  null
  
)

export default component.exports